import { COLORS } from '../constants'

export const handlePieChartData = (payload) => {
  return payload.map((item, index) => {
    return {
      ...item,
      index,
      color:
        item.length < COLORS.length && index > 0
          ? COLORS[index + 1]
          : COLORS[index],
      value: item.numberCompanies,
      pieIndex: index,
      name: item.analysisIndicatorTypeName ?? '',
    }
  })
}
